import React from 'react';
import { NavLink } from 'react-router-dom';
import { LayoutDashboard, FileText, Users, Package, CreditCard } from 'lucide-react';
import { clsx } from 'clsx';

const items = [
  { to: '/dashboard', icon: <LayoutDashboard size={20} />, label: 'Dashboard' },
  { to: '/invoices',  icon: <FileText size={20} />,        label: 'Estimates' },
  { to: '/customers', icon: <Users size={20} />,           label: 'Customers' },
  { to: '/products',  icon: <Package size={20} />,         label: 'Products' },
  { to: '/payments',  icon: <CreditCard size={20} />,      label: 'Payments' },
];

const MobileNav: React.FC = () => (
  <nav id="mobile-nav" className="lg:hidden fixed bottom-0 left-0 right-0 bg-white border-t border-gray-100 z-30">
    <div className="flex items-center justify-around px-1 py-1">
      {items.map(item => (
        <NavLink
          key={item.to}
          to={item.to}
          className={({ isActive }) => clsx(
            'flex flex-col items-center gap-0.5 px-3 py-2 rounded-xl transition-all text-xs font-medium',
            isActive
              ? 'text-primary-600 bg-primary-50'
              : 'text-gray-500 hover:text-gray-700',
          )}
        >
          {item.icon}
          {item.label}
        </NavLink>
      ))}
    </div>
  </nav>
);

export default MobileNav;
